import { render, staticRenderFns } from "./Actions.vue?vue&type=template&id=4752e9be&scoped=true"
import script from "./Actions.vue?vue&type=script&lang=js"
export * from "./Actions.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=4752e9be&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4752e9be",
  null
  
)

export default component.exports